import scrollLock from 'scroll-lock';

class Hamburger {
  constructor() {
    this.node = document.querySelector('.js-hamburger');
    this.isOpen = false;
  }

  open() {
    this.isOpen = true;
    this.node.classList.add('is-open');
  }

  close() {
    this.isOpen = false;
    this.node.classList.remove('is-open');
  }
}

class MobileMenu {
  constructor() {
    this.node = document.querySelector('.js-mobile-menu');
    this.isOpen = false;
  }

  open() {
    this.isOpen = true;
    this.node.classList.add('is-open');
  }

  close() {
    this.isOpen = false;
    this.node.classList.remove('is-open');
  }
}

class Header {
  constructor() {
    this.node = document.querySelector('.js-header');
    this.isOpen = false;

    this.hamburger = new Hamburger();
    this.mobileMenu = new MobileMenu();

    scrollLock.addScrollableTarget(this.mobileMenu.node);

    this.addListeners();    
  }

  addListeners() {
    this.hamburger.node.addEventListener('click', this.click.bind(this))

    // header will be closed if the mobile device is changed to a desktop device
    document.documentElement.addEventListener('changeDevice', ({detail}) => {
      if (this.isOpen && !detail.isMobile) { this.close() }
    })
  
    // close the header when user tap on other place
    document.querySelector('.out').addEventListener('touchstart', ({target}) => {
      if (target === document.querySelector('.out') && this.isOpen) { this.close() }
    })
  }

  click() {
    if (this.isOpen) { this.close() } else { this.open() }
  }

  open() {
    this.isOpen = true;
    this.hamburger.open();
    this.mobileMenu.open();
    scrollLock.disablePageScroll();
  }

  close() {
    this.isOpen = false;
    this.hamburger.close();
    this.mobileMenu.close();
    scrollLock.enablePageScroll();
  }

}

const header = new Header();

export default header;